import React, { useEffect, useState } from 'react';
import './App.css';

function App() {
  const [isInviteOpen, setIsInviteOpen] = useState(false);

  useEffect(() => {
    if (!isInviteOpen) return;
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        setIsInviteOpen(false);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isInviteOpen]);

  return (
    <div className="page">
      <div className="container">
        <header className="brand">
          <img
            src="/zinea-logo-horizontal.png"
            alt="Zinea Lifestyles"
            className="brand-logo"
          />
          <div className="brand-contact">
            <span className="contact-item">
              <span className="contact-icon" aria-hidden="true">📞</span>
              +91 8800404288
            </span>
            <span className="contact-item">
              <span className="contact-icon" aria-hidden="true">✉️</span>
              connect@zinea.app
            </span>
          </div>
        </header>

        <section className="hero">
          <h1>
            A better lifestyle,<br />designed as one system.
          </h1>
          <p>
            Zinea Lifestyles is a bundled lifestyle offering that brings together an
            intelligent app, a private community, and curated D2C products — built to help
            people live better, every day.
          </p>
          <div className="cta">
            <a href="#membership" className="btn">
              Join the Waitlist
            </a>
          </div>
        </section>

        <section className="section">
          <h2>Modern life is fragmented.</h2>
          <p>
            Your goals live in one app. Your habits in another. Your purchases are
            disconnected from how you actually live.
            <br />
            <br />
            Zinea exists to bring everything together — into one calm, intentional lifestyle
            system.
          </p>
        </section>

        <section className="section">
          <h2>One membership. Three connected layers.</h2>
          <div className="grid">
            <div className="card">
              <h3>Zinea App</h3>
              <p>
                The digital brain of your lifestyle. Plan routines, track habits, access
                member-only digital programs, and bring clarity to how you live each day.
              </p>
              <div className="app-links">
                <a href="https://apps.apple.com/app/id6504409326" target="_blank" rel="noopener noreferrer">
                  <img
                    src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                    alt="Download on the App Store"
                  />
                </a>
                <a href="https://play.google.com/store/apps/details?id=com.nipunai.zinea" target="_blank" rel="noopener noreferrer">
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                    alt="Get it on Google Play"
                  />
                </a>
              </div>
              <p className="fine-print">
                App access is included with Zinea Lifestyles Membership.
              </p>
            </div>

            <div className="card">
              <h3>Private Community</h3>
              <p>
                A quiet, members-only circle designed for accountability, learning, and
                meaningful conversations — without noise or algorithms.
              </p>
            </div>

            <div className="card">
              <h3>D2C Products</h3>
              <p>
                Thoughtfully designed physical tools that support focus, rest, and daily
                rituals. Limited releases with member-first access.
              </p>
            </div>
          </div>
        </section>

        <section id="membership" className="section">
          <h2>Zinea Lifestyles Membership</h2>
          <p>
            Zinea is not a product you buy. It’s a system you live with.
            <br />
            <br />
            Membership unlocks the app, the community, and access to curated products and
            experiences.
          </p>
          <div className="cta">
            <button type="button" className="btn" onClick={() => setIsInviteOpen(true)}>
              Request an Invite
            </button>
          </div>
        </section>
      </div>

      {isInviteOpen && (
        <div className="modal-overlay" onClick={() => setIsInviteOpen(false)}>
          <div className="modal-card" onClick={(event) => event.stopPropagation()}>
            <div className="modal-header">
              <h3>Join the Waitlist</h3>
              <button
                type="button"
                className="modal-close"
                onClick={() => setIsInviteOpen(false)}
                aria-label="Close"
              >
                ×
              </button>
            </div>
            <div className="modal-body">
              <iframe
                title="Zinea Life Waitlist"
                src="https://forms.zohopublic.in/connectzi1/form/ZineaLifeWaitlist/formperma/GEOGXeJvfe7noEzWZ8Lytu2Z6ZCWQOPyad-mVl4T_wQ"
                className="invite-iframe"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      )}

      <footer>
        © Zinea Lifestyles. Designed for intentional living.
      </footer>
    </div>
  );
}

export default App;
